<template>
  <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      v-if="dialogVisible" :width="width"
      :before-close="closeDialog" :top="top" class="base-dialog">
    <el-form ref="form" :model="input"  :label-width="labelWidth || '140px'">
      <slot></slot>
    </el-form>
    <div slot="footer" class="dialog-footer" v-if="footer !== false && !$slots.footer">
      <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading" @click="clickSubmit">确 定</el-button>
      <el-button size="mini"  plain icon="el-icon-close" @click="closeDialog">取 消</el-button>
    </div>
    <div slot="footer" class="dialog-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </el-dialog>
</template>
<style scoped lang="scss">
  .base-dialog /deep/ {
    .el-dialog__footer {
      padding: 0;
    }
    .el-form-item__label {
      color: #07a4c7;
    }
  }

  .dialog-footer {
    border-top: 1px solid rgba(#15848D, 0.5);
    background-color: #092e3b;
    height: 45px;
    line-height: 45px;
    padding-right: 10px;
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/dialog/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/dialog/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/dialog/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-dialog')
  export default {
    name: 'base-dialog', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-dialog': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>